import React, {PropsWithChildren} from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement>, PropsWithChildren {}

const Panel = ({...props}:Props) => {
    return (
        <div className={`p-4 rounded-lg bg-gray-100`} {...props}>
            {props.children}
        </div>
    );
};

export default Panel;
